<template>
  <div class="popup-сallback">
    <ButtonClose class="popup-сallback__close" @click="close" />
    <div class="popup-сallback__media">
      <img class="popup-сallback__img" src="@/assets/img/popup_img.jpg" width="416" height="697" alt="">
    </div>
    <div class="popup-сallback__info">
      <Title3 class="popup-сallback__title" v-html="getValue('popup.title')" />
      <p class="popup-сallback__desc" v-html="getValue('popup.subtitle')"></p>
      <CallbackForm class="popup-сallback__form"
        :content="{bnt: getValue('popup.btn.text'), success: getValue('success') }" />
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/element/ButtonClose.vue";
import Title3 from "@/components/element/Title3App.vue";
import CallbackForm from "@/components/block/СallbackForm.vue";
import { getValue } from '@/helpers/index.js';

export default {
  name: 'СallbacPopup',
  components: {
    ButtonClose,
    Title3,
    CallbackForm
  },
  props: {
    content: {
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    getValue() {
      return (path) => {
        return getValue(this.content, path, "");
      }
    },
  },
  methods: {
    close() {
      this.$store.commit('updateClose');
    }
  },
};
</script>

<style>
.popup-сallback {
  position: relative;

  display: flex;
  width: 1298px;

  background-color: #0c1427;
}

.popup-сallback__close {
  position: absolute;
  top: 30px;
  right: 30px;
}

.popup-сallback__media {
  flex-shrink: 0;
  width: 416px;
}

.popup-сallback__img {
  height: 100%;

  object-fit: cover;
  object-position: center;
}

.popup-сallback__info {
  padding: 110px 80px 110px 50px;
}

.popup-сallback__title {
  margin-bottom: 50px;
  text-transform: uppercase;
}

.popup-сallback__desc {
  margin-bottom: 50px;
}

@media screen and (max-width: 1919.98px) {
  .popup-сallback {
    width: 1180px;
  }

  .popup-сallback__close {
    top: 20px;
    right: 20px;
  }

  .popup-сallback__media {
    width: 390px;
  }

  .popup-сallback__info {
    padding: 100px 60px 80px 40px;
  }

  .popup-сallback__title {
    margin-bottom: 45px;
  }

  .popup-сallback__desc {
    margin-bottom: 45px;
  }
}

@media screen and (max-width: 1599.98px) {
  .popup-сallback {
    width: 1080px;
  }

  .popup-сallback__media {
    width: 360px;
  }

  .popup-сallback__title {
    margin-bottom: 40px;
  }

  .popup-сallback__desc {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 1199.98px) {
  .popup-сallback {
    width: 940px;
  }

  .popup-сallback__media {
    width: 340px;
  }

  .popup-сallback__info {
    padding: 100px 60px 80px 40px;
  }

  .popup-сallback__title {
    margin-bottom: 40px;
  }

  .popup-сallback__desc {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 991.98px) {
  .popup-сallback {
    width: 720px;
  }

  .popup-сallback__media {
    width: 340px;
  }

  .popup-сallback__info {
    padding: 70px 40px 40px 30px;
  }

  .popup-сallback__title {
    margin-bottom: 30px;
  }

  .popup-сallback__desc {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 767.98px) {
  .popup-сallback {
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .popup-сallback__media {
    display: none;
  }

  .popup-сallback__info {
    padding: 100px 100px 60px 100px;
  }

  .popup-сallback__title {
    margin-bottom: 30px;
  }

  .popup-сallback__desc {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 575.98px) {
  .popup-сallback {
    width: 100%;
    height: 100%;

  }

  .popup-сallback__info {
    padding: 60px 25px 60px 25px;
  }
}
</style>
